module.exports = __webpack_public_path__ + "static/media/alicebanner_sm1.e6fe0dfb.png";